<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">门禁人员</h1>
			<div>
				<el-select class="select1" v-model="device_id" placeholder="请选择门禁" @change="getDetail()">
		          <el-option v-for="(dev,index) in devList" :label="dev.cname" :key="index" :value="dev.id"></el-option>
		        </el-select>
			</div>
			<br>
			<el-table
			stripe
			border
			:data="tableData"
			style="width: 100%">
				<el-table-column
				type="index"
				width="80">
				</el-table-column>
				
				<el-table-column
					prop="name"
					label="姓名">
				</el-table-column>
				<el-table-column
					prop="enrollid"
					label="编号">
				</el-table-column>
				<el-table-column
					prop="mode"					
					label="身份"
					:formatter="userToChart">
				</el-table-column>
				
				<el-table-column
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small"
							@click="clickChangeName(scope.$index, scope.row)">更名
					</el-button>
					<el-button type="text" size="small"
							@click="clickDoorWay(scope.$index, scope.row)">开门方式
					</el-button>
					
				</template>
				</el-table-column>
			</el-table>
			<br />
			<div class="text-right">
				<el-pagination
					@current-change="handleCurrentChange"
				  :page-size="pageSize"
				  layout="total, prev, pager, next"
				  :total="totalNum">
				</el-pagination>
			</div>
		</div>
		<!--修改人员名称-->
		<el-dialog title="人员更名" :visible.sync="changeDialog" width="500px" >
		    <el-form>
	        	<el-form-item label="姓名" label-width="80px">
			    	<el-input v-model="changeUser.name" auto-complete="off"></el-input>
			    </el-form-item>
	            
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="cancelChangeName()">取消</el-button>
			    <el-button type="primary" @click="confirmChangeDevName()">保存</el-button>
			  </div>
		</el-dialog>
		<!--开门方式-->
		<el-dialog title="开门方式" :visible.sync="doorDialog" width="600px" >
		    <el-table
			stripe
			border
			:data="doorData"
			style="width: 100%">
				<el-table-column
				type="index"
				width="80">
				</el-table-column>
								
				<el-table-column
					prop="backupnum"					
					label="开门方式"
					:formatter="visitWay2">
				</el-table-column>
				<el-table-column
					prop="record"
					label="相关信息">
				</el-table-column>				
				
			</el-table>
			
		</el-dialog>
	</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return {
		device_id: 1,
		devList: [],
		tableData: [],
		nowPage:1,
		pageSize:12,
		totalNum:0,
		beforName:"",
		changeUser: {
			name: ""
		},
		changeDialog: false,
		doorDialog: false,
		doorData:[]

    }
  },
  mounted(){
    this.$nextTick(function(){
		this.getDoors();
    	this.getDetail();
  	})
  },

  methods: {
	getDetail(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			device_id: this.device_id,
			page: 1,
			pagesize: 9999,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/GuardManage/GuardUserList",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.tableData = res.data.data.datalist || [];
				this.totalNum = res.data.data.totalNumber || 0;
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
//			点击更名
	clickChangeName(index,row){
		this.changeUser = row;
		this.beforName= row.name;
		this.changeDialog = true;
	},
	cancelChangeName(){
		this.changeDialog = false;
		this.changeUser.name = this.beforName;
	},
	confirmChangeDevName(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			device_id: this.device_id || "",
			enrollid: this.changeUser.enrollid || "",
			name: this.changeUser.name || "",
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/GuardManage/GuardUsername",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.$message.success(res.data.msg);
				this.changeDialog = false;
				this.getDetail();
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	
	},
	// 点击开门方式
	clickDoorWay(){
		this.doorDialog = true;
		let valiCodeParams={
			uid:this.getCookie('uid'),
			device_id: this.device_id || "",
			enrollid: this.enrollid || "",
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/GuardManage/GuardBackupnumList",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.doorData = res.data.data;
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	// 获取门禁设备列表
	getDoors(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/FaceManage/List",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.devList = res.data.data;
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	handleCurrentChange(val) {
		this.nowPage = val;
		this.getDetail();
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/doorManager.vue